<fieldset class="panel panel-white padding-0">
    <div class="panel-heading border-light">
        <h4 class="panel-title">Refundable Deposit</h4>
        <ul class="panel-heading-tabs border-light">
            <li>
                <div class="btn-group">
                    <button
                        type="button"
                        class="btn-bx-primary"
                        (click)="addDepositInvoice()"
                        [disabled]="depositRows.length > 0"
                        *ngIf="permissionService.isAvailable('jobs.maintain-invoices.create-invoice')">
                        <i class="ti-plus" tooltip="Add refundable deposit" container="body"></i>
                    </button>
                </div>
            </li>
        </ul>
    </div>
    <div class="panel-body">
        <div class="form-group">
            <h4 class="margin-top-10 margin-bottom-10 text-center" *ngIf="!depositRows?.length">
                Click the + button above to create a refundable deposit invoice. <br />
                <a href="https://help.buildxact.com/en/articles/3038696-refundable-deposits" target="_blank">Read more in our FAQ's</a>
            </h4>
            <div class="table-wrapper" #tableWrapper>
                <ngx-datatable
                    [ngStyle]="{ height: depositTableHeight }"
                    *ngIf="depositRows?.length"
                    #depositsTable
                    class="material bxt-table"
                    [rows]="depositRows"
                    [rowHeight]="40"
                    columnMode="force"
                    [scrollbarV]="true"
                    [headerHeight]="50"
                    [footerHeight]="0"
                    [virtualization]="false"
                    [limit]="100">
                    <!-- columns -->
                    <ngx-datatable-column name="Invoice #" prop="InvoiceNumberString" [flexGrow]="1" [minWidth]="95" [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a [class.bxt-row-action]="row.InvoiceNumber !== 0" (click)="viewInvoice(row)">
                                {{ row.InvoiceNumberString }}
                                <i
                                    *ngIf="row.AccSyncData && row.AccSyncData !== 'blocked'"
                                    class="ti-cloud-up"
                                    tooltip="Synced to your accounting software"
                                    container="body"></i>
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Description" prop="Description" [flexGrow]="8" [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a class="bxt-row-action" (click)="viewInvoice(row)">
                                {{ row.Description }}
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Invoiced" prop="InvoiceDate" [flexGrow]="2" [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.InvoiceDate | date }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Due" prop="DueDate" [flexGrow]="2" [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.DueDate | date }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Held (Ex)" prop="Total" [flexGrow]="2" [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.Total | bxCurrency }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Applied (Ex)" [flexGrow]="2" [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ job.DepositUsed | bxCurrency }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Remaining (Ex)" [flexGrow]="2" [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ job.DepositRemaining | bxCurrency }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Status" prop="Status" [flexGrow]="2" [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <span
                                class="label"
                                [ngClass]="{
                                    'label-inverse': row.Status === 'Pending',
                                    'label-warning': row.Status === 'Invoiced',
                                    'label-info': row.Status === 'PartReceived',
                                    'label-success': row.Status === 'Received',
                                }"
                                >{{ row.Status }}</span
                            >
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                        [width]="160"
                        [sortable]="false"
                        [canAutoResize]="false"
                        [draggable]="false"
                        [resizeable]="false"
                        [cellClass]="'right-align'"
                        [headerClass]="'disabled'">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <button
                                type="button"
                                class="btn btn-xs btn-info margin-left-5"
                                (click)="addReceipt(row)"
                                tooltip="Add Payment Receipt"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="row.Status === 'Invoiced' || row.Status === 'PartReceived'">
                                <i class="ti-receipt"></i>
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-default margin-left-5"
                                (click)="shareInvoice(row)"
                                tooltip="Share"
                                container="body"
                                [adaptivePosition]="false">
                                Share
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-default margin-left-5"
                                (click)="printInvoice(row)"
                                tooltip="Print"
                                container="body"
                                [adaptivePosition]="false">
                                <i class="ti-printer"></i>
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-danger margin-left-5"
                                (click)="deleteInvoice($event, row)"
                                [disabled]="row.Status !== 'Pending'"
                                tooltip="Delete"
                                container="body"
                                [adaptivePosition]="false">
                                <i class="ti-trash"></i>
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </div>
    </div>
</fieldset>
